import authCreator from '@web/middlewares/auth'

import {RootState} from '../../../interfaces/result'

const auth = authCreator<RootState>({})

/** 페이 회원 인증 미들웨어  */
export default auth
